<template>
    <secition-card
        title="면접 및 채용"
        v-bind="{
            loading,
        }"
    >
        <v-data-table
            v-bind="{
                headers,
                items,
                'items-per-page': -1,
                'mobile-breakpoint': -1,
            }"
            hide-default-footer
            hide-default-header
            disable-filtering
            disable-pagination
            disable-sort
            dense
        >
            <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" #[`item.${header.value}`]="{ value, item }"> {{ header.formatter(value, item) }} </template>
        </v-data-table>
    </secition-card>
</template>

<script>
import api from "@/api";

import SecitionCard from "@/components/console/dumb/secition-card.vue";
import { APPLICATION_STAGES, APPLICATION_STATES } from "@/assets/variables";

export default {
    components: {
        SecitionCard,
    },
    props: {
        searchDateValue: { type: Array, default: () => [null, null] },
    },
    data: () => ({
        summary: {
            applications: 0,

            meetings: 0,
            recruits: 0,

            avgWorks: {
                years: 0,
                months: 0,
            },
        },

        loading: false,
    }),
    computed: {
        headers() {
            return [
                {
                    text: "분류",
                    value: "_id",
                    formatter: (value) => value || "-",
                },
                {
                    text: "수량",
                    value: "count",
                    align: "end",
                    formatter: (value, item) => `${value?.format?.() || value || "-"}${item.suffix ?? "건"}`,
                },
            ].map((item) => ({ ...item, cellClass: `${item.cellClass || ""} text-caption` }));
        },
        items() {
            let avgWorks = [];
            let { years, months } = this.summary.avgWorks;
            if (0 < years) avgWorks.push(`${this.summary.avgWorks.years.format()}년`);
            if (0 < months) avgWorks.push(`${this.summary.avgWorks.months.format()}개월`);
            avgWorks = avgWorks.join(" ");
            if (!avgWorks.trim()) avgWorks = 0;

            return [
                {
                    _id: "지원자수",
                    count: this.summary.applications,
                    suffix: "명",
                },
                {
                    _id: "면접진행",
                    count: this.summary.meetings,
                    suffix: "건",
                },
                {
                    _id: "최종합격",
                    count: this.summary.recruits,
                    suffix: "건",
                },
                {
                    _id: "면접진행률",
                    count: this.summary.applications ? Math.round((this.summary.meetings / this.summary.applications) * 100) : 0,
                    suffix: "%",
                },
                {
                    _id: "최종합격률",
                    count: this.summary.applications ? Math.round((this.summary.recruits / this.summary.applications) * 100) : 0,
                    suffix: "%",
                },
                {
                    _id: "합격자 평균경력",
                    count: avgWorks,
                    suffix: avgWorks ? "" : "개월",
                },
            ];
        },
    },
    methods: {
        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                const { searchDateValue } = this;

                const {
                    summary: { totalCount: applications },
                } = await api.console.recruitments.applications.gets({
                    _recruitment: undefined,
                    headers: { mode: "count-only" },
                    params: {
                        searchDateKey: "appliedAt",
                        searchDateValue,
                        state: JSON.stringify({ $nin: [APPLICATION_STATES.ON_WRITING.value] }),
                    },
                });
                this.summary.applications = applications;

                const {
                    summary: { totalCount: meetings },
                } = await api.console.recruitments.applications.gets({
                    _recruitment: undefined,
                    headers: { mode: "count-only" },
                    params: {
                        searchDateKey: "appliedAt",
                        searchDateValue,
                        state: JSON.stringify({ $nin: [APPLICATION_STATES.ON_WRITING.value] }),
                        stage: JSON.stringify({ $in: [APPLICATION_STAGES.ON_MEETING.value, APPLICATION_STAGES.ON_RECRUIT.value] }),
                    },
                });
                this.summary.meetings = meetings;

                const {
                    summary: { totalCount: recruits },
                } = await api.console.recruitments.applications.gets({
                    _recruitment: undefined,
                    headers: { mode: "count-only" },
                    params: {
                        searchDateKey: "appliedAt",
                        searchDateValue,
                        state: JSON.stringify({ $nin: [APPLICATION_STATES.ON_WRITING.value] }),
                        stage: JSON.stringify({ $in: [APPLICATION_STAGES.ON_RECRUIT.value] }),
                    },
                });
                this.summary.recruits = recruits;

                const { span: avgWorks } = await api.console.recruitments.applications.gets({
                    _recruitment: undefined,
                    headers: { mode: "average-work-experience-span" },
                    params: {
                        searchDateKey: "appliedAt",
                        searchDateValue,
                        state: JSON.stringify({ $nin: [APPLICATION_STATES.ON_WRITING.value] }),
                        stage: JSON.stringify({ $in: [APPLICATION_STAGES.ON_RECRUIT.value] }),
                    },
                });
                this.summary.avgWorks = avgWorks;
            } finally {
                this.loading = false;
                this.$emit("updated");
            }
        },
    },
    watch: {
        searchDateValue() {
            this.search();
        },
    },
    mounted() {
        this.search();
    },
};
</script>

<style>
</style>